module.exports = __webpack_public_path__ + "img/rep-samantha.0a8bd524.png";